/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateUserRequest
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserRequest
     */
    client_id: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserRequest
     */
    team_id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    role: UpdateUserRequestRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    password?: string;
}


/**
 * @export
 */
export const UpdateUserRequestRoleEnum = {
    NgUser: 'ng_user',
    NgSystemAdmin: 'ng_system_admin',
    NgSupervisor: 'ng_supervisor',
    NgServiceAccount: 'ng_service_account'
} as const;
export type UpdateUserRequestRoleEnum = typeof UpdateUserRequestRoleEnum[keyof typeof UpdateUserRequestRoleEnum];


/**
 * Check if a given object implements the UpdateUserRequest interface.
 */
export function instanceOfUpdateUserRequest(value: object): value is UpdateUserRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('client_id' in value) || value['client_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function UpdateUserRequestFromJSON(json: any): UpdateUserRequest {
    return UpdateUserRequestFromJSONTyped(json, false);
}

export function UpdateUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'client_id': json['client_id'],
        'team_id': json['team_id'] == null ? undefined : json['team_id'],
        'name': json['name'],
        'role': json['role'],
        'password': json['password'] == null ? undefined : json['password'],
    };
}

export function UpdateUserRequestToJSON(json: any): UpdateUserRequest {
    return UpdateUserRequestToJSONTyped(json, false);
}

export function UpdateUserRequestToJSONTyped(value?: UpdateUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'client_id': value['client_id'],
        'team_id': value['team_id'],
        'name': value['name'],
        'role': value['role'],
        'password': value['password'],
    };
}

